<!-- src/components/AppSideMenu.vue -->
<template>
  <nav class="side-menu">
    <h3 class="side-title">메인 메뉴</h3>

    <ul class="menu-list">
      <!-- <li>
        <router-link class="item" to="/dashboard" v-slot="{ isActive }">
          <img
            class="ico"
            :src="isActive ? icons.dashboardGreen : icons.dashboard"
            alt=""
          />
          대시보드
        </router-link>
      </li> -->

      <li v-if="isAdmin" @click="$emit('menu-click')">
        <router-link class="item" to="/invite" v-slot="{ isActive }">
          <img
            class="ico"
            :src="isActive ? icons.profileGreen : icons.profile"
            alt=""
          />
          회원초대
        </router-link>
      </li>

      <!-- 회원 상세에서는 켜진 채로 남고, 누르면 보던 회원관리 목록(필터·쪽)으로 돌아간다(그 밖에서 들어왔으면 /member-list) -->
      <li v-if="isAdmin" @click="$emit('menu-click')">
        <router-link
          class="item"
          :class="{ 'router-link-active': isMemberListProfile }"
          :to="isMemberListProfile ? memberListBackPath : '/member-list'"
          v-slot="{ isActive }"
        >
          <img
            class="ico"
            :src="
              isActive || isMemberListProfile
                ? icons.profileGreen
                : icons.profile
            "
            alt=""
          />
          회원관리
        </router-link>
      </li>

      <!-- 신규회원 관리에서 회원 상세로 들어가면 이 메뉴가 켜진 채로 남고, 누르면 보던 조건의 목록으로 돌아간다 -->
      <li v-if="isAdmin" @click="$emit('menu-click')">
        <router-link
          class="item"
          :class="{ 'router-link-active': isNewMemberProfile }"
          :to="isNewMemberProfile ? newMembersBackPath : '/new-members'"
          v-slot="{ isActive }"
        >
          <img
            class="ico"
            :src="
              isActive || isNewMemberProfile
                ? icons.profileGreen
                : icons.profile
            "
            alt=""
          />
          신규회원 관리
        </router-link>
      </li>

      <!-- 회원권 추세에서 회원 상세로 들어가면 이 메뉴가 켜진 채로 남고, 누르면 보던 탭·필터로 돌아간다 -->
      <li v-if="isAdmin" @click="$emit('menu-click')">
        <router-link
          class="item"
          :class="{ 'router-link-active': isTrendsProfile }"
          :to="isTrendsProfile ? trendsBackPath : '/trends'"
          v-slot="{ isActive }"
        >
          <img
            class="ico"
            :src="
              isActive || isTrendsProfile
                ? icons.dashboardGreen
                : icons.dashboard
            "
            alt=""
          />
          회원권 추세
        </router-link>
      </li>

      <li v-if="isAdmin" @click="$emit('menu-click')">
        <router-link class="item" to="/booking" v-slot="{ isActive }">
          <img
            class="ico"
            :src="isActive ? icons.bookingGreen : icons.booking"
            alt=""
          />
          수업관리
        </router-link>
      </li>

      <li v-if="isAdmin" @click="$emit('menu-click')">
        <router-link class="item" to="/programs" v-slot="{ isActive }">
          <img
            class="ico"
            :src="isActive ? icons.recordsGreen : icons.records"
            alt=""
          />
          운동 프로그램
        </router-link>
      </li>

      <li @click="$emit('menu-click')">
        <router-link
          class="item"
          to="/free-trial-requests"
          v-slot="{ isActive }"
        >
          <img
            class="ico"
            :src="isActive ? icons.recordsGreen : icons.records"
            alt=""
          />
          체험 고객 관리
        </router-link>
      </li>

      <li v-if="isAdmin" @click="$emit('menu-click')">
        <router-link class="item" to="/rewards" v-slot="{ isActive }">
          <img
            class="ico"
            :src="isActive ? icons.profileGreen : icons.profile"
            alt=""
          />
          연속 보상
        </router-link>
      </li>

      <li v-if="isAdmin" @click="$emit('menu-click')">
        <router-link class="item" to="/realtime-hr" v-slot="{ isActive }">
          <img
            class="ico"
            :src="isActive ? icons.recordsGreen : icons.records"
            alt=""
          />
          실시간 심박
        </router-link>
      </li>

      <li v-if="isAdmin" @click="$emit('menu-click')">
        <router-link class="item" to="/machine-records" v-slot="{ isActive }">
          <img
            class="ico"
            :src="isActive ? icons.recordsGreen : icons.records"
            alt=""
          />
          머신 기록
        </router-link>
      </li>

      <li v-if="isAdmin" @click="$emit('menu-click')">
        <router-link class="item" to="/device-management" v-slot="{ isActive }">
          <img
            class="ico"
            :src="isActive ? icons.bookingGreen : icons.booking"
            alt=""
          />
          기기 관리
        </router-link>
      </li>

      <!-- <li>
        <router-link
          class="item"
          :to="isMemberRecords ? $route.path : '/records'"
          v-slot="{ isActive }"
        >
          <img
            class="ico"
            :src="
              isActive || isMemberRecords ? icons.recordsGreen : icons.records
            "
            alt=""
          />
          회원기록
        </router-link>
      </li> -->
    </ul>

    <div class="menu-sep"></div>

    <button class="item item--muted" type="button" @click="$emit('logout')">
      로그아웃
    </button>
  </nav>
</template>

<script>
import icDashboard from "@/assets/icons/ic-dashboard.png";
import icDashboardGreen from "@/assets/icons/ic-dashboard_green.png";
import icBooking from "@/assets/icons/ic-booking.png";
import icBookingGreen from "@/assets/icons/ic-booking_green.png";
import icRecords from "@/assets/icons/ic-records.png";
import icRecordsGreen from "@/assets/icons/ic-records_green.png";
import icProfile from "@/assets/icons/ic-profile.png";
import icProfileGreen from "@/assets/icons/ic-profile_green.png";

export default {
  name: "AppSideMenu",
  props: {
    role: { type: String, default: "" },
  },
  data() {
    return {
      icons: {
        dashboard: icDashboard,
        dashboardGreen: icDashboardGreen,
        booking: icBooking,
        bookingGreen: icBookingGreen,
        records: icRecords,
        recordsGreen: icRecordsGreen,
        profile: icProfile,
        profileGreen: icProfileGreen,
      },
    };
  },
  computed: {
    isAdmin() {
      return this.role === "admin";
    },
    isMemberProfile() {
      return this.$route.name === "MemberProfile";
    },
    // 회원 상세로 들어오기 전 주소 (vue-router가 history.state.back에 남긴다). 새 탭(Ctrl/⌘·가운데 클릭)으로 연 상세는 방문 기록이
    // 없으므로 신규회원 관리가 실어 보낸 ?from=(보던 목록 주소)을 쓴다(3차 리뷰). from은 이 앱 안 주소("/"로 시작, "//" 아님)만 받는다
    memberProfileBackPath() {
      if (!this.isMemberProfile) return "";
      // 주소가 바뀔 때마다 다시 읽도록 fullPath를 거친다
      if (!this.$route.fullPath) return "";
      const back = window.history.state?.back;
      if (typeof back === "string") return back;
      const from = this.$route.query.from;
      return typeof from === "string" && /^\/(?!\/)/.test(from) ? from : "";
    },
    // 신규회원 관리에서 들어온 회원 상세
    isNewMemberProfile() {
      return /^\/new-members(?:[?#]|$)/.test(this.memberProfileBackPath);
    },
    // 회원권 추세(이탈 위험)에서 들어온 회원 상세
    isTrendsProfile() {
      return /^\/trends(?:[?#]|$)/.test(this.memberProfileBackPath);
    },
    // 그 밖의 회원 상세는 지금처럼 회원관리가 켜진다
    isMemberListProfile() {
      return (
        this.isMemberProfile &&
        !this.isNewMemberProfile &&
        !this.isTrendsProfile
      );
    },
    // 예전에는 지금 상세 주소를 가리켜 눌러도 아무 일이 없었다
    memberListBackPath() {
      return /^\/member-list(?:[?#]|$)/.test(this.memberProfileBackPath)
        ? this.memberProfileBackPath
        : "/member-list";
    },
    newMembersBackPath() {
      return this.isNewMemberProfile
        ? this.memberProfileBackPath
        : "/new-members";
    },
    // 보던 탭·이유·연락 상태 필터 그대로
    trendsBackPath() {
      return this.isTrendsProfile ? this.memberProfileBackPath : "/trends";
    },
    isMemberRecords() {
      return this.$route.name === "MemberRecords";
    },
  },
};
</script>

<style scoped>
.side-menu {
  width: 280px;
  background: #151718;
  border-radius: 10px;
  color: #fff;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}
.side-title {
  margin: 4px 0 16px;
  font-size: 18px;
  font-weight: 400;
}
.menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
}

.item {
  width: 100%;
  height: 46px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 12px;
  background: transparent;
  border: 0;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  font-size: 16px;
  letter-spacing: -0.02em;
}
.item.router-link-active {
  background: #1b1d1e;
  border: 1px solid rgba(184, 184, 184, 0.2);
}

.item--muted {
  color: #8e8e8e;
  text-align: left;
}
.menu-sep {
  height: 12px;
}

.ico {
  width: 20px;
  height: 20px;
  display: block;
}
</style>
